import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Nav from "../components/nav";
import createErrorBoundary from "shared/components/wrappers/errorBoundary";

// Access state and use relevant selectors here
const mapStateToProps = (state) => {
  return {
    currentContractor: state.currentContractor,
    currentlyClaimedCalls: state.currentlyClaimedCalls,
    call: state.call,
  };
};

export default createErrorBoundary()(withRouter(connect(mapStateToProps)(Nav)));
